import React from "react";
import "./Activities.css";

const Activities = () => {
  const activities = [
    {
      category: "Governance",
      items: [
        "•	Develop governance policies to support data infrastructure management.",
        "•	Enhance literacy through training and knowledge-sharing programs.",
      ],
    },
    {
      category: "Solutions",
      items: [
        "•	Offer tailored enterprise solutions to help organizations harness data.",
      ],
    },
    
  ];

  return (
    <div className="activities-page">
      <h1 className="activities-title">Our Activities</h1>
      <div className="activities-container">
        {activities.map((activity, index) => (
          <div key={index} className="activity-category">
            <h2 className="activity-category-title">{activity.category}</h2>
            <ul className="activity-list">
              {activity.items.map((item, idx) => (
                <li key={idx} className="activity-item">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Activities;
